module.exports = __webpack_public_path__ + "img/pof.c55a6308.webp";